// start:ng42.barrel
export * from './spinner.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/spinner/index.ts